import { Box, ClickAwayListener, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ApplicationInputStyle, FontStyle } from "../../constants";
import { updateAppData } from "../../utils/actionUtils";
import { useDispatch, useSelector } from "react-redux";
import FettiInput from "../FettiInput";
import FettiSelect from "../FettiSelect";

const QuestionApply = ({ data, idx }) => {
  const dispatch = useDispatch();
  const apply = useSelector((state) => state.apply);
  const responses = useSelector((state) => state.apply.app.questions);
  const { question, type, answerRange } = data;
  const [tempAnswer, setTempAnswer] = useState(responses[idx]);
  const [syncTimeout, setSyncTimeout] = useState(null);
  useEffect(() => {
    if (type === "number" || type === "integer") {
      // sync the answer after 1.5 seconds if validation is required
      setSyncTimeout((t) => {
        if (t) {
          clearTimeout(t);
        }
        return setTimeout(() => {
          validateAndSyncAnswer(tempAnswer);
        }, 2000);
      });
      return;
    }
    // otherwise, sync whenever user types
    validateAndSyncAnswer(tempAnswer);
  }, [tempAnswer]);
  const validateAndSyncAnswer = (v) => {
    let finalValue = v;
    if (finalValue === "") {
      updateAppData(dispatch, {
        questions: responses.map((response, index) => {
          if (index === idx) {
            return finalValue;
          } else {
            return response;
          }
        }),
      });
      return;
    }
    if (type === "number") {
      const value = parseFloat(finalValue);
      if (isNaN(value)) {
        finalValue = answerRange[0];
      } else {
        // round to 2 decimal places
        const roundedValue = Math.round(value * 100) / 100;
        const clampedValue = Math.min(
          Math.max(roundedValue, answerRange[0]),
          answerRange[1]
        );
        if (clampedValue !== finalValue) {
          finalValue = clampedValue;
        }
      }
    } else if (type === "integer") {
      const value = parseInt(finalValue);
      if (isNaN(value)) {
        finalValue = answerRange[0];
      } else {
        const clampedValue = Math.min(
          Math.max(value, answerRange[0]),
          answerRange[1]
        );
        if (clampedValue !== finalValue) {
          finalValue = clampedValue;
        }
      }
    }
    // data.setAnswer(finalValue);
    updateAppData(dispatch, {
      questions: responses.map((response, index) => {
        if (index === idx) {
          return finalValue;
        } else {
          return response;
        }
      }),
    });
    setTempAnswer(finalValue);
  };
  return (
    <Stack direction="column" spacing={1}>
      <Box
        sx={{
          ...FontStyle.body,
          fontSize: "18px",
        }}>
        {idx + 1}. {question}
      </Box>
      <Box sx={ApplicationInputStyle.subheader}>Your response</Box>
      <ClickAwayListener onClickAway={() => validateAndSyncAnswer(tempAnswer)}>
        <Box>
          {type === "number" || type === "integer" ? (
            <FettiInput
              value={tempAnswer}
              placeholder="Expected answer"
              onChange={(v) => setTempAnswer(v.target.value)}
            />
          ) : (
            <FettiSelect
              options={["Select an option", "Yes", "No"].map(
                (option, index) => ({
                  value: option,
                  label: option,
                })
              )}
              firstIsPlaceholder
              value={tempAnswer}
              onChange={(v) => setTempAnswer(v.target.value)}
            />
          )}
        </Box>
      </ClickAwayListener>
      <Box
        sx={{
          width: "100%",
          paddingTop: 2,
          paddingBottom: 1,
        }}>
        <Box
          sx={{
            height: "1px",
            width: "100%",
            backgroundColor: "#E0E0E0",
          }}
        />
      </Box>
    </Stack>
  );
};

export default QuestionApply;
